module.exports = __webpack_public_path__ + "img/s-Imoo-p-2.bd7498ee.png";